import React, { useEffect, useState } from "react";
import jQuery from "jquery";
// reactstrap components
import { Card, CardHeader, CardBody, Row, Col, Spinner, Input, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

// core components
// Require Font Awesome.
import 'font-awesome/css/font-awesome.css';
import { BASE_URL } from "utils/constants";
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";
import { RichBox } from "components/RichBoxComponent";

function isNullOrUndefined(obj){
  if(obj === undefined || obj === null){
    return true;
  }
  return false;
}

function Froala(props) {
    const [data,setData] = useState(props.data)

    const onChange = (contents) => {
      if (!isNullOrUndefined(props.onChange)){ props.onChange(contents);}
      onChangeTxt(contents);
    };
    const onChangeTxt = (contents) => {
        setData(contents);    
    };


    const submitHandler = async(e) => {
        e.preventDefault();
        let body = {
            gId: props.gId,
            stId: props.id,
            proId: props.proId,
            section: props.section,
            details: data,
            x:"EEEEEE"
        };

        try {
            if(props.type == 'group'){
                await axios.post(`${BASE_URL}/student/submitproject.php`, body);
                Swal.fire('Submitted Successfully', '', 'success');
            } else {
                await axios.post(`${BASE_URL}/student/submitindpro.php`, body);
                Swal.fire('Submitted Successfully', '', 'success');
            }

        } catch {
            Swal.fire('Something Went Wrong', '', 'error');
        }
    }

    return (
      <>
              <Row>
                  <Col md={12}>
                  {/* **************** Test return froala editor ************* */}
                      <div className="col-12" id="bodyarea">
                        <RichBox defaultValue = {data} onChange={(data)=>{onChange(data);}} />
                      </div>
                      <div className="text-center">
                          <button disabled={props.locked=="1"} className="btn btn-primary w-50 fw-bolder mx-auto" onClick={(e)=>submitHandler(e)}>Submit</button>
                      </div>
                  </Col>
              </Row>

      </>
    );
}

export default Froala;